export default {"src":"/_next/static/media/get-quote.706781f2.svg","height":59,"width":60};